import httpClient from "../../api/httpClient";
import Projeto from "../classes/Projeto";

interface HttpCalls {
  method: string;
  rota: string;
}

const calls: HttpCalls[] = [
  { method: "GET", rota: "Projeto/All" },
  { method: "GET", rota: "Projeto/{id}" },
  { method: "POST", rota: "Projeto/Adicionar" },
  { method: "PUT", rota: "Projeto/Atualizar" },
  { method: "DELETE", rota: "Projeto/Apagar" }
];

const cacheKey: string = "ProjetoCache";
const cacheKeySelC: string = "ProjetoSelecionado";
const apiServico: String = "PLANEJAMENTO"

class ProjetoDataset extends httpClient {

  constructor() {
    super(String(apiServico));
  }

  async ListarAtivos(): Promise<Projeto[]> {
    return await super.Get(calls[0].rota)
      .then((response) => {
        return JSON.parse(JSON.stringify(response.data));
      })
      .catch((erro) => {
        console.error(erro)
      });
  }

  Adicionar(value: Projeto) {
    let ok: boolean = false;
    let error: any = undefined;
    super.post(calls[2].rota, value).then((result) => {
      ok = JSON.parse(result);
    }).catch((erro) => {
      ok = false;
      error = erro;
    });
    if (error !== undefined && ok === false)
      throw error;
  }

  Atualizar(value: Projeto) {
    let ok: boolean = false;
    let error: any = undefined;
    super.put(calls[3].rota, value).then((result) => {
      ok = JSON.parse(result);
    }).catch((erro) => {
      ok = false;
      error = erro;
    });
    if (error !== undefined && ok === false)
      throw error;
  }

  Apagar(value: Projeto) {
    let ok: boolean = false;
    let error: any = undefined;
    super.delete(calls[4].rota, value).then((result) => {
      ok = JSON.parse(result);
    }).catch((erro) => {
      ok = false;
      error = erro;
    });
    if (error !== undefined && ok === false)
      throw error;
  }

  getKeyCach(): string {
    return cacheKey;
  }

  getKeyCachClass(): string {
    return cacheKeySelC;
  }

  ListarFromCache(): Projeto[] {
    let result: Projeto[] = JSON.parse(cacheKey);
    return result;
  }

  AdicionarListaAoCache(value: Projeto[]) {
    localStorage.setItem(cacheKey, JSON.stringify(value));
  }

  LimparListaDoCache() {
    localStorage.removeItem(cacheKey);
  }

  AdicionarObjetoAoCache(value: Projeto) {
    localStorage.setItem(cacheKeySelC, JSON.stringify(value));
  }

  LimparObjetoDoCache() {
    localStorage.removeItem(cacheKeySelC);
  }

}
export default ProjetoDataset;

